import axios from 'axios';
import { ArticleGetResponse } from '../../../features/article/model/articleModel';

export const AuthApi = {
  getMe: () => {
    return axios.get<ArticleGetResponse>(`/api/me`);
  },
};
